export enum AdType {
    FULL_SIZE,
    SAP_DESKTOP,
    SAP_MOBILE,
}
